import * as tslib_1 from "tslib";
import * as React from 'react';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import strings from 'owa-strings/owa-common-strings';
import { MeCardPane } from 'owa-header-pane';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { observer } from 'mobx-react';
import HeaderCharm from './HeaderCharm';
var HeaderPersona = /** @class */ (function (_super) {
    tslib_1.__extends(HeaderPersona, _super);
    function HeaderPersona() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderPersona.prototype.render = function () {
        var userConfiguration = getUserConfiguration();
        var emailAddress = userConfiguration.SessionSettings.UserEmailAddress;
        return (React.createElement(HeaderCharm, { title: strings.headerPersonaCharm_ariaLabel, ariaLabel: strings.headerPersonaCharm_ariaLabel, icons: {
                charmContent: (React.createElement(PersonaControl, { name: userConfiguration.SessionSettings.UserDisplayName, emailAddress: emailAddress, secondaryText: emailAddress, size: PersonaSize.size32, hexConsumerIdForUser: userConfiguration.HexCID })),
            }, behavior: {
                charm: 3 /* PersonaCharm */,
                paneComponent: MeCardPane,
            } }));
    };
    HeaderPersona = tslib_1.__decorate([
        observer
    ], HeaderPersona);
    return HeaderPersona;
}(React.Component));
export default HeaderPersona;
//# sourceMappingURL=HeaderPersona.js.map